import React, { useRef } from 'react';
var VeltCommentPinGhostCommentIndicator = function (props) {
    var annotationId = props.annotationId, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-pin-ghost-comment-indicator", { ref: ref, "annotation-id": annotationId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentPinGhostCommentIndicator;
